import { httpClient } from "core/api";
import {
  CollaboratorFilters,
  CollaboratorProfile,
  CollaboratorProfileCreatePayload,
  CollaboratorDashboardByUuidResponse,
  CollaboratorProfileSubordinate,
  CollaboratorProfileUpdatePayload,
  CollaboratorProfileWithRelations,
  WorkSessionsParams,
} from "../model/collaborator-profile.types";
import { ApiWorkSessionsResponse } from "features/architecture/worksessions/model";
import { WorkSessionSummary } from "features/architecture/worksessions/model/work-session.responses";

const baseRoute = "/collaborator_profiles";

export const collaboratorProfilesApi = {
  create: (payload: CollaboratorProfileCreatePayload) =>
    httpClient.post<CollaboratorProfile>(`${baseRoute}`, payload),
  getAll: () => httpClient.get<CollaboratorProfile[]>(`${baseRoute}`),
  getById: (id: number) =>
    httpClient.get<CollaboratorProfileWithRelations>(`${baseRoute}/id/${id}`),
  updateById: (id: number, payload: CollaboratorProfileUpdatePayload) =>
    httpClient.patch<CollaboratorProfile>(`${baseRoute}/id/${id}`, payload),
  deleteById: (id: number) =>
    httpClient.delete<CollaboratorProfile>(`${baseRoute}/id/${id}`),
  getByFilters: (filters?: CollaboratorFilters) => {
    const params: Record<string, string> = {};

    if (filters?.collaboratorId?.length) {
      params.collaboratorId = filters.collaboratorId.join(",");
    }

    if (filters?.directorId?.length) {
      params.directorId = filters.directorId.join(",");
    }

    if (filters?.teamId?.length) {
      params.teamId = filters.teamId.join(",");
    }

    return httpClient.get<CollaboratorProfileWithRelations[]>(
      `${baseRoute}/filters`,
      {
        params,
      },
    );
  },
  getMe: () =>
    httpClient.get<CollaboratorProfileWithRelations | null>(`${baseRoute}/me`),
  getFormAdmin: () =>
    httpClient.get<CollaboratorProfileWithRelations[]>(
      `${baseRoute}/getForAdmin`,
    ),
  getMyLastWorkSession: async (signal?: AbortSignal) => {
    const response = await httpClient.get<WorkSessionSummary | null>(
      `${baseRoute}/me/last_work_session`,
      {
        signal,
      },
    );

    return response;
  },
  getDashboardByUuid: (uuid: string, signal?: AbortSignal) =>
    httpClient.get<CollaboratorDashboardByUuidResponse>(
      `${baseRoute}/dashboard/${uuid}`,
      {
        signal,
      },
    ),
  getSubordinates: (id: number) =>
    httpClient.get<CollaboratorProfileSubordinate[]>(
      `${baseRoute}/${id}/subordinates`,
    ),
  getWithWorkSessions: (
    id: number,
    params?: WorkSessionsParams,
    signal?: AbortSignal,
  ) =>
    httpClient.get<ApiWorkSessionsResponse>(
      `${baseRoute}/${id}/work_sessions`,
      {
        params,
        signal,
      },
    ),
  getWithLastWorkSession: async (id: number, signal?: AbortSignal) => {
    const response = await httpClient.get<WorkSessionSummary | null>(
      `${baseRoute}/${id}/last_work_session`,
      {
        signal,
      },
    );

    return response;
  },
};
